import React from 'react';
import PlusCard from './PlusCard';

// ── The one Plus prompt ───────────────────────────────────────────────────
//
// Opened wherever a Plus feature is asked for on a monitor without Plus:
// the Share button (Settings), the leak section's "See Plus" (Alerts), and
// the Home banner. A short reason line, then the same Plus card as
// Settings → Plus (activate / start, with the plan choice and the fine print).

const LEAD = {
  sharing: 'Sharing is part of SoKo Plus.',
  leak: 'Usage and leak alerts are part of SoKo Plus.',
  alerts: 'Text and push alerts, more levels and offline alerts are part of SoKo Plus.',
};

export default function PlusPromptModal({ open, onClose, deviceId, plus, isOwner, reason }) {
  if (!open) return null;
  const lead = LEAD[reason] || null;
  return (
    <div className="modal-backdrop plus-modal" onClick={onClose} role="presentation">
      <div className="plus-modal__box" onClick={(e) => e.stopPropagation()}
        role="dialog" aria-modal="true" aria-label="SoKo Plus">
        {lead && <p className="plus-modal__lead">{lead}</p>}
        <PlusCard deviceId={deviceId} plus={plus} isOwner={isOwner} onNotNow={onClose} />
        {!isOwner && (
          <button type="button" className="btn btn-secondary plus-modal__close" onClick={onClose}>Close</button>
        )}
      </div>
    </div>
  );
}
